<template>
    <div class="bill_addon clr">
        <standart
            title="Службова записка "
            key="order_addon_inbox"
            v-bind:is_active_result=true
            v-bind:is_active_problem=true
            v-bind:is_active_title=true
        ></standart>
    </div>
</template>

<script>
import standart from '../standart.vue'

export default {
    name: "inbox_imc",
    components: {
        standart,
    },
    
}

</script>

<style scoped>

</style>
